import { render, staticRenderFns } from "./benefits.vue?vue&type=template&id=fefaa812&scoped=true"
import script from "./benefits.vue?vue&type=script&lang=js"
export * from "./benefits.vue?vue&type=script&lang=js"
import style0 from "./benefits.vue?vue&type=style&index=0&id=fefaa812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefaa812",
  null
  
)

export default component.exports